import { Mail, Users, FileText, Play, CheckCircle } from 'lucide-react'
import { useRecentActivity } from '@hooks/useDashboard'
import { formatDateTime } from '@lib/utils'
import { ActivityItem } from '@services/dashboard.service'

const activityIcons = {
  campaign_started: Play,
  campaign_completed: CheckCircle,
  client_imported: Users,
  template_created: FileText,
}

const activityColors = {
  campaign_started: 'text-blue-600 bg-blue-50',
  campaign_completed: 'text-green-600 bg-green-50',
  client_imported: 'text-purple-600 bg-purple-50',
  template_created: 'text-orange-600 bg-orange-50',
}

export function RecentActivity() {
  const { data: activities, isLoading, error } = useRecentActivity(10)

  if (isLoading) {
    return (
      <div className="space-y-4">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="flex items-start gap-3">
            <div className="h-10 w-10 animate-pulse rounded-lg bg-gray-200" />
            <div className="flex-1 space-y-2">
              <div className="h-4 w-3/4 animate-pulse rounded bg-gray-200" />
              <div className="h-3 w-1/2 animate-pulse rounded bg-gray-200" />
            </div>
          </div>
        ))}
      </div>
    )
  }

  if (error) {
    return (
      <p className="text-center text-sm text-gray-500">
        Failed to load recent activity
      </p>
    )
  }

  if (!activities || activities.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8">
        <Mail className="mb-2 h-12 w-12 text-gray-300" />
        <p className="text-sm text-gray-500">No recent activity</p>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {activities.map((activity: ActivityItem) => {
        const Icon = activityIcons[activity.type] || Mail
        const colorClass = activityColors[activity.type] || 'text-gray-600 bg-gray-50'

        return (
          <div key={activity.id} className="flex items-start gap-3">
            <div className={`flex h-10 w-10 items-center justify-center rounded-lg ${colorClass}`}>
              <Icon size={18} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 dark:text-white">
                {activity.message}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                {formatDateTime(activity.timestamp)}
              </p>
            </div>
          </div>
        )
      })}
    </div>
  )
}
